import _get from 'lodash/get'
import React, { useCallback, useEffect, useState } from 'react'
import { getTitle } from '../utils/getTitle'
import { ClientReferralForm } from './form/ClientReferralForm'
//import { ReferralRevenue } from './form/ReferralRevenue'
import { connect } from 'react-redux'
import { listForReferrals } from '../../_common/core/http_services/brands'
import { ReferralsByBrand } from './form/ReferralsByBrand'
import { showAxiosError } from '../utils/messenger'

const ClientReferralPage = props => {
  useEffect(() => {
    Messenger.options = {
      extraClasses: 'messenger-fixed messenger-on-top',
      theme: 'future',
    }
    const configDocTitle = _get(props.configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle)
  }, [props.configs])
  const brandId = props.brand.id
  const [isLoading, setIsLoading] = useState(true)
  const refetch = useCallback(async () => {
    try {
      setIsLoading(true)
      const result = await listForReferrals(brandId)
      const referrals = result.attributes.map(referral => ({
        ...referral,
        name: referral.first_name + ' ' + referral.last_name,
      }))
      setReferrals(referrals)
    } catch (e) {
      showAxiosError(e)
    } finally {
      setIsLoading(false)
    }
  }, [brandId])
  const [referrals, setReferrals] = useState([])
  useEffect(() => {
    refetch()
  }, [refetch])
  return (
    <div>
      <ClientReferralForm brandId={brandId} refetch={refetch} />
      <ReferralsByBrand referrals={referrals} brandId={brandId} refetch={refetch} isLoading={isLoading} />
      {/*<ReferralRevenue />*/}
    </div>
  )
}

export default connect(state => {
  const brand = state.brands.selected
  return {
    brand,
  }
})(ClientReferralPage)
